/**
 * @file
 * @author dailin01
*/
import Link from './link';
export default Link;
